import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LandingSearchbarComponent } from './landing-searchbar.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [LandingSearchbarComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [LandingSearchbarComponent]
})
export class LandingSearchBarModule { }